<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="documents">
    <ItemCommonDescription
      :data-card="dataCard.data[0]"
      :document-link="documentLink"
      :data-values="dataCard.value"
      @reload-data-card="reloadDataCard"
    />
    <div class="file-details-block has-side-bars">
      <ItemList :data-table="documentTable" />
    </div>
    <ItemViews :views="dataCard.data[0].popularity" />
    <ItemsRelated :card-id="dataCard.data[0].id" />
  </div>
</template>

<script>
import ItemCommonDescription from './ItemCommonDescription.vue'
import ItemViews from './ItemViews'
import ItemList from './ItemList.vue'
import ItemsRelated from './ItemsRelated'
import { t } from '../../i18n/index'
/**
 * Document view disposition
 * @example [none]
 */
export default {
  name: 'DocumentItem',
  components: { ItemCommonDescription, ItemViews, ItemList, ItemsRelated },
  props: {
    /**
     * Item object information getted by api
     */
    dataCard: {
      type: Object,
    },
  },
  computed: {
    documentLink() {
      return this.dataCard.value && this.dataCard.value['dc.identifier.uri']
    },
    documentTable() {
      let docTable = []
      if (this.dataCard && this.dataCard.value) {
        if (this.dataCard.value['dc.contributor.author']) {
          docTable.push({
            name: t('doc_auth'),
            desc: Array.isArray(this.dataCard.value['dc.contributor.author'])
              ? this.dataCard.value['dc.contributor.author'].join(', ')
              : this.dataCard.value['dc.contributor.author'],
          })
        }
        if (this.dataCard.value['dc.subject']) {
          docTable.push({
            name: t('doc_subj'),
            desc: this.dataCard.value['dc.subject.category']
              ? (Array.isArray(this.dataCard.value['dc.subject'])
                  ? this.dataCard.value['dc.subject'].join(', ')
                  : this.dataCard.value['dc.subject']) +
                ' / ' +
                this.dataCard.value['dc.subject.category']
              : Array.isArray(this.dataCard.value['dc.subject'])
              ? this.dataCard.value['dc.subject'].join(', ')
              : this.dataCard.value['dc.subject'],
          })
        }
        if (this.dataCard.value['dc.coverage.spatial']) {
          docTable.push({
            name: t('doc_geo'),
            desc: this.dataCard.value['dc.coverage.spatial'],
          })
        }
        if (this.dataCard.value['dc.publisher']) {
          docTable.push({
            name: t('doc_publish'),
            desc: this.dataCard.value['dc.publisher'],
          })
        }
        if (this.dataCard.value['dc.format.extent']) {
          docTable.push({
            name: t('doc_ext'),
            desc: this.dataCard.value['dc.format.extent'],
          })
        }
        if (this.dataCard.value['dc.rights']) {
          docTable.push({
            name: t('doc_terms_use'),
            desc: this.dataCard.value['dc.rights'],
          })
        }
        if (this.dataCard.value['dc.subject.forma']) {
          docTable.push({
            name: t('doc_colections'),
            desc: Array.isArray(this.dataCard.value['dc.subject.forma'])
              ? this.dataCard.value['dc.subject.forma'].join(', ')
              : this.dataCard.value['dc.subject.forma'],
          })
        }
      }
      return docTable
    },
  },
  methods: {
    reloadDataCard() {
      this.$emit('reload-data-card')
    },
  },
}
</script>

<style lang="stylus" scoped>
.documents
  display: flex
  flex-direction: column
  width: 100%
  gap: vw(10px)

  .file-details-block
    display: flex
    flex-direction: column
    padding-bottom: vw(25px)
    width: 100%
</style>
